<template>
  <div class="documents-report-filters">
    <c-button-2 v-if="open" class="documents-report-filters__toggler" label="Скрыть фильтры" @click="open = false" />

    <transition name="slide">
      <div v-show="open" class="documents-report-filters__slide">
        <div v-if="inited" class="documents-report-filters__wrapper">
          <c-input-2
            v-model="form.filials"
            class="documents-report-filters__item documents-report-filters__filial"
            label="Филиал"
            type="select"
            :checkbox-value="form.filialsExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.filials"
            @checkboxChange="form.filialsExcept = $event"
          />
          <c-input-2
            v-model="form.positions"
            class="documents-report-filters__item documents-report-filters__position"
            label="Должность"
            type="select"
            :checkbox-value="form.positionsExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.positions"
            @checkboxChange="form.positionsExcept = $event"
          />
          <c-input-2
            v-model="form.nameOrPhone"
            class="documents-report-filters__item documents-report-filters__query"
            label="Имя или телефон"
            placeholder="Любые"
            :clearable="true"
            @enter="$emit('apply')"
          />
          <c-input-2
            v-model="form.analyseTypes"
            class="documents-report-filters__item documents-report-filters__doc-type"
            label="Тип анализа"
            type="select"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.analyseTypes"
            :checkbox-value="form.analyseTypesExcept"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            @checkboxChange="form.analyseTypesExcept = $event"
          />
          <c-select
            v-model="form.analyses"
            class="documents-report-filters__item documents-report-filters__document"
            type="select"
            label="Наименование анализа"
            :multiple="true"
            :searchable="true"
            :placeholder="'Все'"
            :items="collections.analyses"
            :groups="collections.analyseTypes"
            :checkbox="true"
            :checkbox-type="'icon'"
            :checkbox-tooltip="exceptTooltip"
            @checkboxChange="form.analysesExcept = $event"
          />
          <c-input-2
            v-model="form.expirationTypes"
            class="documents-report-filters__item documents-report-filters__deadline"
            type="select"
            label="Срок годности анализа"
            :multiple="true"
            :placeholder="'Все'"
            :items="collections.expirationTypes"
          />
          <c-range
            v-model="form.expiresAfter"
            class="documents-report-filters__item range documents-report-filters__deadline-range"
            :max="35"
            :min="0"
            label="Истекает срок годности в течение, дн."
          />
          <c-switcher
            v-model="form.withProblems"
            class="documents-report-filters__item switcher documents-report-filters__problems"
            label="Проблемы с анализами"
          />
          <div class="documents-report-filters__item documents-report-filters__actions">
            <c-button size="large" class="documents-report-filters__reset" label="Сбросить" @click="reset" />
            <c-button
              class="documents-report-filters__apply"
              label="Применить"
              color="blue"
              size="large"
              @click="apply"
            />
          </div>
        </div>
      </div>
    </transition>

    <c-button-2 v-if="open" class="documents-report-filters__toggler" label="Скрыть фильтры" @click="open = false" />

    <c-button-2 v-if="!open" class="documents-report-filters__toggler" label="Показать фильтры" @click="open = true" />
  </div>
</template>

<script>
import Input2 from "@/components/controls2/Input";
import Select from "@/components/controls2/Select";
import Button2 from "@/components/controls2/Button";
import Switcher from "@/components/controls/switcher";
import Range from "@/components/controls/range";
import Button from "@/components/controls/button";
import { generateQueryParameter } from "../../../../helpers/medicalAnalysesReportHelper";
import { userPermissionsList } from "@/constants/userPermissions";

const exceptTooltip = {
  disabledText: "Фильтр по всем значениям в справочнике, кроме выбранных",
  activeText: "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
  notActiveText: "Включить фильтр по всем значениям в справочнике, кроме выбранных",
};

export default {
  name: "medical-analyses-report-filters",

  components: {
    "c-input-2": Input2,
    "c-select": Select,
    "c-switcher": Switcher,
    "c-range": Range,
    "c-button": Button,
    "c-button-2": Button2,
  },

  data() {
    return {
      inited: false,
      open: false,

      exceptTooltip,
      collections: {
        filials: [],
        positions: [],
        analyseTypes: [],
        analyses: [],
        expirationTypes: [],
      },
      form: {
        filials: [],
        filialsExcept: false,
        positions: [],
        positionsExcept: false,
        nameOrPhone: "",
        analyseTypes: [],
        analyseTypesExcept: false,
        analyses: [],
        analysesExcept: false,
        expirationTypes: [],
        expiresAfter: [0, 0],
        withProblems: false,
      },
    };
  },

  watch: {
    "form.filials": function (v) {
      if (!v.length) {
        this.form.filialsExcept = false;
      }
    },
    "form.positions": function (v) {
      if (!v.length) {
        this.form.positionsExcept = false;
      }
    },
    "form.analyseTypes": function (v) {
      if (!v.length) {
        this.form.analyseTypesExcept = false;
      }
    },
  },

  mounted() {
    Promise.all([
      this.$store
        .dispatch("filters/loadFilials", {
          all: userPermissionsList.reports.medicalAnalyses.all,
          own: userPermissionsList.reports.medicalAnalyses.own,
        })
        .then((res) => {
          this.collections.filials = res;
        }),
      this.$store.dispatch("filters/loadPositions").then((res) => {
        this.collections.positions = res;
      }),
      this.$store.dispatch("medicalAnalysesForm/fetchAnalysesForReport").then(({ groups, items }) => {
        this.collections.analyseTypes = groups;
        this.collections.analyses = items;
      }),
      this.$store.dispatch("filters/loadExpirationTypes").then((types) => {
        this.collections.expirationTypes = types;
      }),
    ]).then(() => {
      this.setDefaultParams();
      this.inited = true;
      this.$emit("inited");
    });
  },

  methods: {
    getFilterParams() {
      return {
        expireInDaysFrom: this.form.expiresAfter[0],
        expireInDaysTo: this.form.expiresAfter[1],
        filials: {
          values: this.form.filials.map((i) => i.value),
          except: this.form.filialsExcept,
        },
        positions: {
          values: this.form.positions.map((i) => i.value),
          except: this.form.positionsExcept,
        },
        analyseTypes: {
          values: this.form.analyseTypes.map((i) => i.value),
          except: this.form.analyseTypesExcept,
        },
        analyses: {
          values: this.form.analyses.map((i) => i.value),
          except: this.form.analysesExcept,
        },
        expirationTypes: this.form.expirationTypes.map((i) => i.value),
        nameOrPhone: this.form.nameOrPhone.trim(),
        hasProblem: this.form.withProblems ? 1 : 0,
      };
    },

    getParams() {
      const filters = this.getFilterParams();
      const params = [];

      Object.entries(filters).forEach(([key, data]) => {
        const parameter = generateQueryParameter(key, data);
        if (parameter) {
          params.push(parameter);
        }
      });

      const query = params.join("&");

      this.saveParams(query);

      return query;
    },
    saveParams(queryString) {
      const query = {};

      queryString.split("&").forEach((param) => {
        const [key, value] = param.split("=");
        if (value) {
          query[key] = value;
        }
      });

      this.$router
        .replace({
          name: "medical-analyses-report",
          query,
        })
        .catch(() => {});
    },

    setDefaultParams() {
      const queryParams = this.$route.query;

      if (queryParams.hasProblem) {
        this.form.withProblems = !!queryParams.hasProblem;
      }
      if (queryParams.expirationType) {
        this.form.expirationTypes = this.collections.expirationTypes.filter(
          (type) => type.value === queryParams.expirationType,
        );
      }
      if (queryParams.expireInDaysFrom) {
        this.form.expiresAfter[0] = +queryParams.expireInDaysFrom;
      }
      if (queryParams.expireInDaysTo) {
        this.form.expiresAfter[1] = +queryParams.expireInDaysTo;
      }
      if (queryParams.filialIds) {
        const filialIds = queryParams.filialIds.split(",");
        this.form.filials = this.collections.filials.filter((filial) => filialIds.includes(String(filial.value)));
      }
      if (queryParams.filialIdsExcept) {
        const filialIds = queryParams.filialIdsExcept.split(",");
        this.form.filials = this.collections.filials.filter((filial) => filialIds.includes(String(filial.value)));
        this.form.filialsExcept = true;
      }
      if (queryParams.postCodes) {
        const postCodes = queryParams.postCodes.split(",");
        this.form.positions = this.collections.positions.filter((post) => postCodes.includes(post.value));
      }
      if (queryParams.postCodesExcept) {
        const postCodes = queryParams.postCodesExcept.split(",");
        this.form.positions = this.collections.positions.filter((post) => postCodes.includes(post.value));
        this.form.positionsExcept = true;
      }
      if (queryParams.search) {
        this.form.nameOrPhone = queryParams.search;
      }
      if (queryParams.medicalAnalysesTypeIds) {
        const typeIds = queryParams.medicalAnalysesTypeIds.split(",");
        this.form.analyseTypes = this.collections.analyseTypes.filter((type) => typeIds.includes(String(type.value)));
      }
      if (queryParams.medicalAnalysesTypeIdsExcept) {
        const typeIds = queryParams.medicalAnalysesTypeIdsExcept.split(",");
        this.form.analyseTypes = this.collections.analyseTypes.filter((type) => typeIds.includes(String(type.value)));
        this.form.analyseTypesExcept = true;
      }
      if (queryParams.medicalAnalysesIds) {
        const analyseIds = queryParams.medicalAnalysesIds.split(",");
        this.form.analyses = this.collections.analyses.filter((analyse) => analyseIds.includes(String(analyse.value)));
      }
    },

    reset() {
      this.form.filials = [];
      this.form.filialsExcept = false;
      this.form.positions = [];
      this.form.positionsExcept = false;
      this.form.nameOrPhone = "";
      this.form.analyseTypes = [];
      this.form.analyseTypesExcept = false;
      this.form.analyses = [];
      this.form.expirationTypes = [];
      this.form.expiresAfter = [0, 0];
      this.form.withProblems = false;

      this.apply();
    },

    apply() {
      this.getParams();
      this.$emit("apply");
    },
  },
};
</script>

<style lang="scss" scoped src="../scss/filters.scss"></style>
